import {
  getArticleTopicRequestParams,
  getTopicRequestParams,
} from 'sly/resourceCenter/helpers';
import TopicPage from 'sly/resourceCenter/pages/Topic';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default TopicPage;

export async function getServerSideProps({ query, params, resolvedUrl }) {
  const { api, store } = createApiClient(apiEndpoints);
  let search = '';
  if (resolvedUrl.indexOf('?') >= 0) {
    search = resolvedUrl.substring(resolvedUrl.indexOf('?'));
  }

  if (query?.['tag-name']) {
    return {
      redirect: {
        destination: `/resource-center/tag/${query?.['tag-name']}`,
        permanent: true,
      },
    };
  }

  const { topic } = params;
  const topicParams = getTopicRequestParams(params);
  const articleParams = getArticleTopicRequestParams(search, topic);
  try {
    await Promise.all(
      [
        api.getTopic.asAction(topicParams),
        api.getArticle.asAction(articleParams),
        api.getResourceCenterCommonInfo.asAction(),
        api.getTopicHeader.asAction(),
      ].map(store.dispatch)
    );
  } catch (e) {
    console.error(e);
    return {
      redirect: {
        destination: '/resource-center',
        permanent: false,
      },
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
      topicParams,
      articleParams,
    },
  };
}
